import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { DrinkOptionTypes, FoodOptionTypes, VenueOption } from "sweet-global";
import OutlineButton from "sweet-web/components/universal/Button/OutlineButton";
import Input from "sweet-web/components/universal/Input";
import CostInput from "sweet-web/components/universal/Input/CostInput";
import SelectInput from "sweet-web/components/universal/Input/SelectInput";
import { Indent } from "sweet-web/components/universal/View";

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 10px 0;
`;

const emptyFoodOption: VenueOption = {
  type: "FOOD",
  subType: "DINNER",
  description: "",
  startingCost: {
    amount: null,
    currency: "USD",
    type: "SERVING"
  }
};

const emptyDrinkOption: VenueOption = {
  type: "DRINK",
  subType: "OPENBAR",
  description: "",
  startingCost: {
    amount: null,
    currency: "USD",
    type: "DRINK"
  }
};

type Props = {
  type: "FOOD" | "DRINK";
  optionId?: string;
  optionEntity?: VenueOption;
  onSave: (space: VenueOption) => void;
  onCancel: () => void;
};

const EditOption: React.FC<Props> = props => {
  const [option, setOption] = useState(
    props.optionEntity
      ? props.optionEntity
      : props.type == "FOOD"
      ? emptyFoodOption
      : emptyDrinkOption
  );

  useEffect(() => {
    if (props.optionEntity) setOption(props.optionEntity);
  }, [props.optionEntity]);

  return (
    <Indent>
      <SelectInput
        title={"Category"}
        value={option.subType}
        options={props.type == "FOOD" ? FoodOptionTypes : DrinkOptionTypes}
        onChange={value => {
          setOption(o => ({
            ...o,
            subType: value
          }));
        }}
      />
      <CostInput
        title={"Starting Cost"}
        type={props.type}
        description="Rough base price for this option"
        value={option.startingCost}
        onChange={value => {
          setOption(o => ({
            ...o,
            startingCost: value
          }));
        }}
      />
      <Input
        title={"Description"}
        value={option.description}
        multiline={true}
        onChange={value => {
          setOption(o => ({
            ...o,
            description: value
          }));
        }}
      />
      <Buttons>
        <OutlineButton
          title="Save"
          style={{ marginRight: 10 }}
          onClick={() => {
            setOption(
              props.type == "FOOD" ? emptyFoodOption : emptyDrinkOption
            );
            props.onSave(option);
          }}
        />
        <OutlineButton
          title="Cancel"
          color="gray"
          onClick={() => {
            setOption(
              props.type == "FOOD" ? emptyFoodOption : emptyDrinkOption
            );
            props.onCancel();
          }}
        />
      </Buttons>
    </Indent>
  );
};

export default EditOption;
